/**
 * Generates a regulation link URL from a regulation number.
 * Example: "872.5410" -> "https://www.ecfr.gov/current/title-21/chapter-I/subchapter-H/part-872/subpart-F/section-872.5410"
 *
 * Pattern:
 * - Part: First part before the dot (e.g., "872")
 * - Subpart: Letter based on first digit after the dot (A=0, B=1, C=2, D=3, E=4, F=5, etc.)
 * - Section: Full regulation number (e.g., "872.5410")
 */
export const generateRegulationLink = (
  regulationNumber?: string | null
): string | null => {
  if (!regulationNumber) {
    return null;
  }

  const parts = regulationNumber.split('.');
  if (parts.length < 2) {
    return null;
  }

  const part = parts[0];
  const afterDot = parts[1];

  if (!afterDot || afterDot.length === 0) {
    return null;
  }

  // Get first digit after the dot to determine subpart letter
  const firstDigit = parseInt(afterDot[0], 10);
  if (isNaN(firstDigit)) {
    return null;
  }

  // Map digit to subpart letter (A=0, B=1, C=2, D=3, E=4, F=5, etc.)
  const subpartLetter = String.fromCharCode(65 + firstDigit); // 65 is 'A' in ASCII

  return `https://www.ecfr.gov/current/title-21/chapter-I/subchapter-H/part-${part}/subpart-${subpartLetter}/section-${regulationNumber}`;
};
